import React from 'react';
import { describeEditionLicenses } from './editionDisplay';
import EditLicenseAction from './editLicenseAction';

/*
 * The read-only view of what an edition gives: one row per license, the tier beside it. The names
 * come from the catalog, so a license the catalog has not returned reads "Unknown license" rather
 * than vanishing from the edition.
 */
const EditionLicensesList = (props) => {
	const { edition, catalog, onEditLicense } = props;
	const rows = describeEditionLicenses(edition, catalog);

	if (rows.length === 0) {
		return <p className="text-muted mb-0">This edition has no licenses.</p>;
	}

	return (
		<table className="table table-sm align-middle mb-0">
			<thead>
				<tr>
					<th scope="col">License</th>
					<th scope="col">Tier</th>
					{onEditLicense && <th scope="col" className="text-end">Actions</th>}
				</tr>
			</thead>
			<tbody>
				{rows.map((row, index) => {
					return (
						<tr key={`${row.licenseId}-${index}`}>
							<td>{row.licenseName}</td>
							<td>{row.tierName}</td>
							{onEditLicense && (
								<td className="text-end">
									<EditLicenseAction row={row} onEditLicense={onEditLicense} />
								</td>
							)}
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default EditionLicensesList;
